import React, { useState, useEffect } from 'react';
import { langAPI } from '../api';
import LanguageFlag from './LanguageFlag';

export default function LanguageSelector({ value, onChange, label }) {
  const [languages, setLanguages] = useState([]);

  useEffect(() => {
    langAPI.list().then((res) => setLanguages(res.data)).catch(() => {
      setLanguages([
        { code: 'en', name: 'English', nativeName: 'English', flag: '🇺🇸' },
        { code: 'zh', name: 'Chinese', nativeName: '中文', flag: '🇨🇳' },
        { code: 'es', name: 'Spanish', nativeName: 'Español', flag: '🇪🇸' },
        { code: 'fr', name: 'French', nativeName: 'Français', flag: '🇫🇷' },
        { code: 'ja', name: 'Japanese', nativeName: '日本語', flag: '🇯🇵' },
        { code: 'ko', name: 'Korean', nativeName: '한국어', flag: '🇰🇷' },
      ]);
    });
  }, []);

  return (
    <div className="field">
      {label && <label>{label}</label>}
      <div className="lang-options">
        {languages.map((lang) => (
          <button
            key={lang.code}
            type="button"
            className={`lang-btn ${value === lang.code ? 'selected' : ''}`}
            onClick={() => onChange(lang.code)}
          >
            {lang.flag} {lang.nativeName}
          </button>
        ))}
      </div>
    </div>
  );
}
